import { createPortal } from "react-dom"

// Global bottom blur veil — used across every page that renders a
// .page-panel (About, Work, Leadership, Writing, Contact, etc.). Always
// visible (no scroll-triggered fade), pinned to the bottom of the
// viewport. Built as stacked layers with progressively stronger blur +
// tight mask bands (see .page-bottom-fade in styles.css).
//
// Mounted once in App.js (not per-page) so it's shared across routes.
// Rendered via portal straight into <body> — .page-panel has a permanent
// backdrop-filter (and briefly a transform during its mount animation),
// either of which turns it into a containing block for position:fixed
// descendants, which would make a "fixed" veil scroll with the panel's
// own overflow instead of staying pinned to the real viewport. The
// portal escapes that entirely.
export default function BottomBlurVeil() {
  return createPortal(
    <div className="page-bottom-fade" aria-hidden="true">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>,
    document.body
  )
}
